module.exports = __webpack_public_path__ + "img/filter.5e8fd8e9.svg";